export function Spinner({ color, width }) {
  return <div className="spinner" style={{ background: `${color}`, width: `${width}px` }} />
}
